<template>
  <div
    class="AppIcon"
    :class="{
      isSquare,
      isEmpty: !src,
    }"
    :style="computedStyle">
  </div>
</template>

<script>
export default {
  name: 'AppIcon',

  props: {
    src:      { type: String,  default: null },
    size:     { type: Number,  default: 64 },
    isSquare: { type: Boolean, default: true },
  },

  computed: {
    computedStyle() {
      return {
        backgroundImage: `url(${this.src ? this.src : 'none'})`,
        width:     !this.isSquare ? '100%' : `${this.size}px`,
        height:    `${this.size}px`,
        minWidth:  `${this.size}px`,
        minHeight: `${this.size}px`,
        maxWidth:  `${Math.floor(this.size * 2.25)}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.AppIcon {
  background-position: left center;
  background-repeat: no-repeat;
  background-size: contain;
  &.isSquare {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  &.isEmpty {
    background-color: $grey;
  }
}
</style>
